module.exports = __webpack_public_path__ + "img/card-configuration-services-and-cost.f15b22b0.svg";